import { openAction, closeAction, clearOverlay } from './action';
import KfOverlay from './kf-overlay.riot';
export { KfOverlay };
export * from './action';

// reducer
export default (state = {}, action) => {
  switch (action.type) {
    case String(openAction): {
      const { name, props, size, x, y } = action.payload;
      return {
        ...state,
        [name]: {
          show: true,
          size,
          props,
          x,
          y,
        },
      };
    }

    case String(closeAction): {
      const { name } = action.payload;
      return {
        ...state,
        [name]: {
          ...state[name],
          show: false,
          props: {},
        },
      };
    }

    case String(clearOverlay):
      return {};

    default:
      return state;
  }
};